// マスター突合：氏名完全一致 + 正規化名寄せ候補 + 未登録

import type { Driver, MatchResult, MatchStatus } from "../types";
import { isExcludedEmployee } from "../data/excludedEmployees";
import { isRetiredDriver } from "./driverStatus";

export function matchDrivers(
  csvNames: { name: string; nameNormalized: string; code?: string }[],
  drivers: Driver[],
  targetMonthFirstDay?: string // YYYY-MM-DD（契約終了日チェック用）
): MatchResult[] {
  const exact = new Map<string, Driver>();
  const norm = new Map<string, Driver[]>();
  for (const d of drivers) {
    if (!d.name) continue;
    if (targetMonthFirstDay && isRetiredDriver(d) && d.contractTo && d.contractTo < targetMonthFirstDay) {
      // 退職済み（状態列が正）かつ契約終了日が対象月初より前 → 在籍判定で外す
      continue;
    }
    exact.set(d.name, d);
    const arr = norm.get(d.nameNormalized) || [];
    arr.push(d);
    norm.set(d.nameNormalized, arr);
  }

  const seen = new Set<string>();
  const results: MatchResult[] = [];
  for (const c of csvNames) {
    if (seen.has(c.name)) continue;
    seen.add(c.name);
    // 雇用（社員）は委託料の集計対象外 → 突合結果に含めない（未登録エラーにしない / 通知書も作らない）
    if (isExcludedEmployee(c.nameNormalized)) continue;
    let status: MatchStatus = "unmatched";
    let driverId: string | null = null;
    let driverName: string | null = null;
    let candidates: Driver[] = [];
    const ex = exact.get(c.name);
    if (ex) {
      status = "matched";
      driverId = ex.id;
      driverName = ex.name;
    } else {
      const cand = norm.get(c.nameNormalized) || [];
      if (cand.length === 1) {
        // 正規化一致1件のみ → 候補
        status = "candidate";
        candidates = cand;
      } else if (cand.length > 1) {
        status = "candidate";
        candidates = cand;
      } else {
        status = "unmatched";
      }
    }
    results.push({
      csvName: c.name,
      csvCode: c.code || "",
      status,
      driverId,
      driverName,
      candidates,
    });
  }
  return results;
}
